import { FormattedMessage } from "react-intl";
import { REPRESENTATIVE, COMPANY_NAME, CONTACT_EMAIL, UST_ID, WIR_ID, ADDRESS_LINE_1, ADDRESS_LINE_2, ADDRESS_LINE_3 } from "./privacy/constants";

export default function Imprint() {
    return(
        <div>
            <div className="navbar">
                <a href="/">
                    <img src="assets/pb_icon.png" alt=""/>
                </a>
                <a href="/" className="navbtn">
                    <FormattedMessage id="pureBudget"/>
                </a>
                <a href="/privacy" className="navbtn">
                    <FormattedMessage id="privacy"/>
                </a>
                <a href="/imprint" className="navbtn active">
                    <FormattedMessage id="imprint"/>
                </a>
                <a href="/contact" className="navbtn">
                    <FormattedMessage id="contact"/>
                </a>
            </div>
            <div className="centered main">
                <h1><FormattedMessage id="imprint"/></h1>
                <div className="featureCard">
                    <span className="bold"><FormattedMessage id="tmg"/></span>
                    <p>
                        {REPRESENTATIVE}<br/>
                        {COMPANY_NAME}<br/><br/>
                        {ADDRESS_LINE_1}<br/>
                        {ADDRESS_LINE_2}<br/>
                        {ADDRESS_LINE_3}
                    </p>
                    <span className="bold"><FormattedMessage id="contact"/></span>
                    <p>
                        <FormattedMessage id="email"/> <a href={"mailto:"+CONTACT_EMAIL} target="_blank" rel="noreferrer">{CONTACT_EMAIL}</a>
                    </p>
                    <span className="bold"><FormattedMessage id="ustId"/></span>
                    <p>
                        <FormattedMessage id="ustIdInfo"/><br/>
                        {UST_ID}
                    </p>
                    <span className="bold"><FormattedMessage id="wirId"/></span>
                    <p>
                        {WIR_ID}
                    </p>
                    <span className="bold"><FormattedMessage id="dispute"/></span>
                    <p>
                        <FormattedMessage id="disputeInfo"/>
                    </p>
                </div>
            </div>
        </div>
    );
}